if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('input', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.trim().length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.trim().length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.searchSuggestionsAbortController = new AbortController();

fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&resources[type]=query,collection&resources[limit]=4&section_id=search-suggestions`, {
          signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          if (this.searchInput.value !== terms) return;
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          if (results && results.firstElementChild) this.insertAdjacentElement('beforeend', results.firstElementChild);
        })
        .catch((error) => {
          console.warn(error); // eslint-disable-line no-console
          if (error.code === 20) {
            return; // aborted
          }
          this.oldSearchValue = null;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}

